import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ProfileState} from './profile.reducers';

export const selectProfileState = createFeatureSelector<ProfileState>('profile');

export const selectProfile = createSelector(
  selectProfileState,
  (state) => state.profile
);
export const selectProfileLoyalty = createSelector(
  selectProfileState,
  (state) => state.profile?.loyalty
);

export const selectProfileLoading = createSelector(
  selectProfileState,
  (state) => state.loading
);

export const selectProfileError = createSelector(
  selectProfileState,
  (state) => state.error
);

export const selectPreferredLanguageCode = createSelector(
  selectProfileState,
  (state) => state.profile?.preferences.lang
);
